import React, { useRef, useState } from 'react';
import './SearchField.css';
import IconSearch from './IconSearch';
import IconMic from './IconMic';

const SearchField = ({
  input,
  onInputChange,
  onSendClick,
  onTranscribeAudio,   
  sttError,            
  sttUploading,        
}) => {
  const suggestionText = "Suche nach Videos und Sendungen in der ARD Mediathek";

  const [recording, setRecording] = useState(false);
  const [localError, setLocalError] = useState(""); 

  const mediaRecorderRef = useRef(null);
  const chunksRef = useRef([]);

  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      onSendClick();
    }
  };

  const startRecording = async () => {
    setLocalError('');

    if (!navigator.mediaDevices || typeof navigator.mediaDevices.getUserMedia !== 'function') {
      setLocalError('This browser does not support the recording of audio via your microphone.');
      return;
    }

    try {
      const stream = await navigator.mediaDevices.getUserMedia({ audio: true });

      const recorder = new MediaRecorder(stream);
      chunksRef.current = [];

      recorder.ondataavailable = (event) => {
        if (event.data.size > 0) {
          chunksRef.current.push(event.data);
        }
      };

      recorder.onstop = async () => {
        const blob = new Blob(chunksRef.current, { type: 'audio/webm' });
        chunksRef.current = [];

        if (onTranscribeAudio) {
          onTranscribeAudio(blob);
        }
      };

      mediaRecorderRef.current = recorder;
      recorder.start();
      setRecording(true);
    } catch (err) {
      console.error(err);

      if (err.name === 'NotAllowedError' || err.name === 'SecurityError') {
        setLocalError('Access to your microphone is denied. Please enable it in your browser settings.');
      } else if (err.name === 'NotFoundError' || err.name === 'DeviceNotFoundError') {
        setLocalError('No microphone found. Please connect one and try again.');
      } else {
        setLocalError('Error in recording. Please try again later.');
      }
    }
  };

  const stopRecording = () => {
    setLocalError('');
    if (!mediaRecorderRef.current) return;

    mediaRecorderRef.current.stop();
    mediaRecorderRef.current.stream.getAudioTracks().forEach((track) => track.stop());

    setRecording(false);
  };

  const handleMicClick = () => {
    if (recording) {
      stopRecording();
    } else {
      startRecording();
    }
  };

  const combinedError = localError || sttError;

  return (

    <div className="search-container">
      <div className="search-field-inner" style={{position: 'relative'}}>
        <div className="icon-container">
          <button
            className="search-button"
            onClick={onSendClick}
            aria-label="Search"
            type="button"
            tabIndex={-1}
            style={{background: 'none', border: 'none', padding: 0, margin: 0}}
          >
            <IconSearch size="28" />
          </button>
        </div>
        <input
          type="text"
          value={input}
          onChange={(e) => onInputChange(e.target.value)}
          placeholder={suggestionText}
          aria-label="Search"
          className="search-input"
          onKeyDown={handleKeyDown}
        />
        <div style={{position: 'absolute', right: 15, top: '50%', transform: 'translateY(-50%)', display: 'flex', alignItems: 'center', gap: 8}}>
          <button
            className="mic-button"
            onClick={handleMicClick}
            type="button"
            disabled={sttUploading}
            aria-label="Spracheingabe"
            title={
              recording
                ? 'Aufnahme stoppen'
                : 'Sprache aufnehmen und in Text umwandeln'
            }
          >
            <span className={recording ? 'mic-icon recording' : 'mic-icon'}>
              <IconMic size={24} />
            </span>
          </button>
        </div>
      </div>

      {combinedError && (
        <div className="search-error">{combinedError}</div>
      )}

      {sttUploading && !combinedError && (
        <div className="search-info">Transkribiere Audio…</div>
      )}
    </div>
  );
};

export default SearchField;
